import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getContacts() {
        try{            
            const response = await axios.get(`Billing/contacts`, {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                     
            return response
        }catch (error){
            console.log('Billing api getContacts error')
            throw error
        }
    },
    async addContact(data) {
        try {       
            const response = await axios.post(`Billing/contact`, 
            {
                contact: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                     
            return response
        }catch (error){
            console.log('Billing api addContact error')
            throw error
        }
    },
    async updateContact(data) {
        try {       
            const response = await axios.patch(`Billing/contact`, 
            {
                contact: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                     
            return response
        }catch (error){
            console.log('Billing api updateContact error')
            throw error
        }
    },
    async deleteContact(data) {
        try {       
            const response = await axios.post(`Billing/contact/delete`, 
            {
                contact: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                     
            return response
        }catch (error){
            console.log('Billing api deleteContact error')
            throw error
        }
    },
    async getBillingByCompany(companyId, calendarYear) {
        try{            
            const response = await axios.get(`Billing/${companyId}/${calendarYear}`, {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                  
            return response
        }catch (error){
            console.log('Billing api getBillingByCompany error')
            throw error
        }
    },
    async getBillingDetails(companyId, cutOffDate) {
        try{            
            const response = await axios.get(`Billing/${companyId}/${cutOffDate}`, {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })
            return response
        }catch (error){
            console.log('Billing api getBillingDetails error')
            throw error
        }
    },
    async getBillingDetailsByInvoiceId(companyId, invoiceId) {
        try{            
            const response = await axios.get(`Billing/${companyId}/invoice/${invoiceId}`, {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                  
            return response
        }catch (error){
            console.log('Billing api getBillingDetailsByInvoiceId error')
            throw error
        }
    },
    async getSoaUrl(companyId, invoiceId) {
        try{            
            const response = await axios.get(`Billing/${companyId}/soa-url/${invoiceId}`, {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                 
            return response
        }catch (error){
            console.log('Billing api getSoaUrl error')
            throw error
        }
    },
    async getPrintedInvoiceUrl(data) {
        try{            
            const response = await axios.post(`Billing/invoice/printed/url`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                  
            return response
        }catch (error){
            console.log('Billing api getPrintedInvoiceUrl error')
            throw error
        }
    },
    async getPaymentAttachmentUrl(data) {
        try{            
            const response = await axios.post(`Billing/payment/attachment/url`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                 
            return response
        }catch (error){
            console.log('Billing api getPaymentAttachmentUrl error')
            throw error
        }
    },
    async deleteProofOfPaymentAttachment(data) {
        try{            
            const response = await axios.post(`Billing/payment/attachment/delete`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                  
            return response
        }catch (error){
            console.log('Billing api deleteProofOfPaymentAttachment error')
            throw error
        }
    },
    async deleteContact(data) {
        try {       
            const response = await axios.post(`Billing/contact/delete`, 
            {
                contact: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                     
            return response
        }catch (error){
            console.log('Billing api deleteContact error')
            throw error
        }
    },
    async forPaymentReview(data) {
        try {       
            const response = await axios.post(`Billing/payment/forreview`, 
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.company_billing
                }
            })                     
            return response
        }catch (error){
            console.log('Billing api forPaymentReview error')
            throw error
        }
    },
}